import { ReduxStore } from 'store/types';

export const selectShowConnectionIndicator = (store: ReduxStore) =>
    store.connection.showConnectionIndicator;

export const selectWarnOnMobileData = (store: ReduxStore) =>
    store.connection.warnOnMobileData;
